import styled from '@emotion/styled';

export const TimelineFilterBase = styled.div`
    display: flex;
    font-size: ${(p) => p.theme.fontSize.mediumLarge};
    align-items: center;
    flex-wrap: wrap;
    padding: ${(p) => p.theme.padding.small};
    & > * {
        flex: 1 1 107px;
    }
    width: 100%;
`;
